import { call, chat } from '@microsoft/teams-js';

export const openChatWithUser = async (email: string, message: string) => {
  if (chat.isSupported()) {
    await chat.openChat({
      user: [email] as unknown as string,
      message: message,
    });
  }
};

export const callUserDirectly = async (email: string) => {
  if (call.isSupported()) {
    await call.startCall({
      targets: [email],
      requestedModalities: [call.CallModalities.Audio],
    });
  }
};
